import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Page from "../../../components/page/Page";
import { Button } from "@vshp/ui-components";
import { fetchPage } from "../../../actions/page";
import { fetchOrgSettings } from "../../../actions/settings";
import { useRouter } from "next/router";
import { wrapper } from "../../../store";
import Head from "next/head";
import PageNotFound from "../../_error";
import { renderCollapseBtn } from "../../../components/utils/render-collapse-btn";

export const getServerSideProps = wrapper.getServerSideProps((store) => async ({ resolvedUrl }) => {
  await Promise.all([store.dispatch(fetchPage(resolvedUrl)), store.dispatch(fetchOrgSettings())]);
});

function SvedenPage() {
  const { page, pageAreLoading } = useSelector((state) => state.page);
  const router = useRouter();
  let backBtnUrl = router.pathname.slice(0, router.pathname.lastIndexOf("/"));

  useEffect(() => {
    const onScroll = (e) => {
      let currentTable = e.target;
      let currentTableWrap = currentTable.closest(".scrollable");

      if (currentTable.scrollLeft + currentTable.offsetWidth + 5 >= currentTable.querySelector("table").offsetWidth) {
        currentTableWrap.classList.remove("scrollable-mobile");
      } else if (!currentTable.matches("scrollable-mobile")) {
        currentTableWrap.classList.add("scrollable-mobile");
      }
    };

    if (!pageAreLoading && page.content) {
      document.querySelectorAll(".scrollable").forEach((item) => {
        item.offsetWidth < item.querySelector("table").offsetWidth && item.classList.add("scrollable-mobile");
        item.querySelector(".scrollable__inner").addEventListener("scroll", onScroll);
      });

      document.querySelectorAll("td.collapsable").forEach((item) => {
        item.textContent.length > 70 ? item.appendChild(renderCollapseBtn()) : item.classList.remove("collapsable");
      });
    }

    return () =>
      document.querySelectorAll(".scrollable").forEach((item) => {
        item.querySelector(".scrollable__inner").removeEventListener("scroll", onScroll);
      });
  }, [page.content]);

  const backBtn = (
    <div className="text-center">
      <Button onClick={() => router.replace(backBtnUrl)} maxWidth={true}>
        Вернуться назад
      </Button>
    </div>
  );

  if (pageAreLoading && page.length <= 0) {
    return <PageNotFound />;
  }

  return (
    <>
      <Head>
        <title>{page.title}</title>
      </Head>
      <Page title={page.title} isExtraBlock={true} extraContent={backBtn} isWysiwyg={false}>
        <div dangerouslySetInnerHTML={{ __html: page.content }}></div>
      </Page>
    </>
  );
}

export default SvedenPage;
